var scope_0 = require('/builds/prairial/landing-page/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0af689c7f8319299f566b3276f0c601f.js').default;
var scope_1 = require('/builds/prairial/landing-page/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/10c51c2144d6461e0042a77505ff833f.js').default;
var scope_2 = require('/builds/prairial/landing-page/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/59cb0041579d8aae4846135a62671d14.js').default;
var scope_3 = require('/builds/prairial/landing-page/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c89b97350fd5be892a75eeb82414da54.js').default;
var scope_4 = require('/builds/prairial/landing-page/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    